import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table is-fullwidth is-hoverable"
}
const _hoisted_2 = { class: "app-title-column" }
const _hoisted_3 = { class: "app-name" }
const _hoisted_4 = { class: "app-description" }
const _hoisted_5 = { class: "action has-icon" }
const _hoisted_6 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "action has-icon" }
const _hoisted_9 = { class: "icon-container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "lozenge-mode"
}
const _hoisted_12 = { class: "button" }
const _hoisted_13 = { class: "app-name" }
const _hoisted_14 = { class: "delete-icon" }
const _hoisted_15 = ["onClick"]

import CapableAppModal from './CapableAppModal.vue';
import ContentHighlightsEditModal from '../contentHighlights/ContentHighlightsEditModal.vue';
import { appsApi } from '@/features/apps/shared/services/apps';
import { InstalledApp } from '@/features/apps/shared/models';
import { ConfigRequest } from './configRequest';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import Draggable from 'vuedraggable';
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';

export interface DraggableChangeEvent {
  moved: {
    newIndex: number;
    oldIndex: number;
    element: Element;
  };
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CapableAppPicker',
  props: {
  capability: {
    type: String,
    required: true,
  },
  selectedApps: {
    type: Array as PropType<ConfiguredAppIntegration[]>,
    required: true,
  },
  configRequest: {
    type: Function as PropType<() => Promise<ConfigRequest>>,
    required: true,
  },
  modalHeading: {
    type: String,
    required: true,
  },
  isLozengeMode: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update", "change"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const capableApps = ref<InstalledApp[]>([]);
const showModal = ref(false);
const showAppEditModal = ref(false);
const editingAppIndex = ref<number>();
const apps = ref<ConfiguredAppIntegration[]>([]);

const hasSelectedApps = computed(
  () => !!apps.value && apps.value.length > 0 && capableApps.value && capableApps.value.length > 0,
);

watch(
  () => props.selectedApps,
  (value: ConfiguredAppIntegration) => (apps.value = value),
  { immediate: true },
);

onMounted(() => {
  appsApi.getCapableApps(currentWorkspace.value.id, [props.capability]).then((apps) => {
    capableApps.value = apps.map((app) => app as InstalledApp);
  });
});

function appAdded(installedAppId: string, config: any) {
  apps.value.push({ installedAppId, config });
  emitChangeEvent();
}

function appRemoved(index: number) {
  apps.value.splice(index, 1);
  emitChangeEvent();
}

function appsMoved(e: DraggableChangeEvent) {
  if (e.moved) {
    emitChangeEvent();
  }
}

function getName(installedAppId: string) {
  return getCapableApp(installedAppId).name;
}

function getDescription(installedAppId: string) {
  return getCapableApp(installedAppId).description || 'Private app';
}

function openContentHighlightsEditModal(appIndex: number) {
  showAppEditModal.value = true;
  editingAppIndex.value = appIndex;
}

function handleAppSave(app: ConfiguredAppIntegration, appIndex: number) {
  emit('update', app, appIndex);
  showAppEditModal.value = false;
  editingAppIndex.value = undefined;
}

function canEditApp(app: ConfiguredAppIntegration): boolean {
  const contentHighlightsApp = capableApps.value.find((a: InstalledApp) => a.appId === 'contenthighlights');

  if (!contentHighlightsApp) {
    return false;
  }

  if (app.installedAppId !== contentHighlightsApp.installedAppId) {
    return false;
  }

  return true;
}

function getCapableApp(installedAppId: string) {
  return capableApps.value.find((ca: InstalledApp) => ca.installedAppId === installedAppId) as InstalledApp;
}

function emitChangeEvent() {
  emit('change', apps.value);
}


return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (showModal.value)
      ? (_openBlock(), _createBlock(CapableAppModal, {
          key: 0,
          modalHeading: __props.modalHeading,
          capableApps: capableApps.value,
          configRequest: __props.configRequest,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false)),
          onCompleted: appAdded
        }, null, 8, ["modalHeading", "capableApps", "configRequest"]))
      : _createCommentVNode("", true),
    (showAppEditModal.value && editingAppIndex.value !== undefined)
      ? (_openBlock(), _createBlock(ContentHighlightsEditModal, {
          key: 1,
          "app-config": apps.value[editingAppIndex.value],
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (showAppEditModal.value = false)),
          onSave: _cache[2] || (_cache[2] = (app) => handleAppSave(app, editingAppIndex.value!))
        }, null, 8, ["app-config"]))
      : _createCommentVNode("", true),
    (!__props.isLozengeMode)
      ? (_openBlock(), _createBlock(_component_n_button, {
          key: 2,
          variant: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = true))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Add an app...")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    (hasSelectedApps.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (!__props.isLozengeMode)
            ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
                _createElementVNode("tbody", null, [
                  _createVNode(_unref(Draggable), {
                    onChange: appsMoved,
                    list: apps.value,
                    group: "apps",
                    "ghost-class": "ghost",
                    class: "draggable-table",
                    "item-key": "installedAppId"
                  }, {
                    item: _withCtx(({ element: item, index }) => [
                      (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: "draggable-row"
                      }, [
                        _createElementVNode("td", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, _toDisplayString(getName(item.installedAppId)), 1),
                          _createElementVNode("div", _hoisted_4, _toDisplayString(getDescription(item.installedAppId)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_5, [
                          (canEditApp(item))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("span", {
                                  onClick: ($event: any) => (openContentHighlightsEditModal(index))
                                }, [
                                  _createVNode(EditIcon)
                                ], 8, _hoisted_7)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: ($event: any) => (appRemoved(index)),
                              class: "trash-icon"
                            }, _cache[6] || (_cache[6] = [
                              _createElementVNode("use", {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#trash"
                              }, null, -1)
                            ]), 8, _hoisted_10))
                          ])
                        ])
                      ]))
                    ]),
                    _: 1
                  }, 8, ["list"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(Draggable), {
                  onChange: appsMoved,
                  list: apps.value,
                  group: "apps",
                  "ghost-class": "ghost",
                  class: "draggable-table-lozenge",
                  draggable: ".draggable-row",
                  "item-key": "installedAppId"
                }, {
                  item: _withCtx(({ element: item, index }) => [
                    (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "draggable-row"
                    }, [
                      _createElementVNode("button", _hoisted_12, [
                        _createVNode(_component_font_awesome_icon, { icon: "cube" }),
                        _createElementVNode("span", _hoisted_13, "Send an app: " + _toDisplayString(getName(item.installedAppId)), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("a", {
                            class: "delete is-small",
                            onClick: _withModifiers(($event: any) => (appRemoved(index)), ["stop"])
                          }, null, 8, _hoisted_15)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["list"])
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (__props.isLozengeMode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(["add-action", { 'has-actions': hasSelectedApps.value }])
        }, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showModal.value = true))
          }, [
            _createVNode(AddIcon),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "add-label" }, "Add action", -1))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})